import React, { Component } from 'react';

import EditPageContentStoreItem from './EditPageContentStoreItem';


import '../css/EditPageContentStores.css';

class EditPageContentStores extends Component {
    constructor() {
        super();
        this.state = {
            id: "",
            url: ""
        };
    }

    handleChange(e) {
        let obj = {};
        obj[e.target.name] = e.target.value;
        this.setState({ ...obj });
    }

    handleAddStore(e){
        e.preventDefault();

        let Store= {id: this.state.id, url: this.state.url}
        this.props.callBackAddStore(Store);
    }

    handleRemoveStore(id){
        this.props.callBackRemoveStore(id);
    }

    render() {
        return (
            <div className="editAppStores" >
                <div>
                    <label htmlFor="id">Stores</label>
                    <select name="id" id="store" onChange={this.handleChange.bind(this)} >
                        <option value="">Seleciona um Loja</option>
                        <option value="android">Android</option>
                        <option value="ios">iOS</option>
                        <option value="huawei">Huawei</option>
                        <option value="facebook">Facebook</option>
                        <option value="web">web</option>
                    </select>                    
                
                    <label htmlFor="url">URl DA LOJA</label>
                    <input type="url" name="url" id="url" onChange={this.handleChange.bind(this)} value={this.state.url} />
                    <br/>
                    <button type="button" className="btn btn-primary" onClick={this.handleAddStore.bind(this)}>Adiciona Link</button>
                </div>
                
                {this.props.stores.map(store => <EditPageContentStoreItem key={store.id}  id={store.id} url={store.url} callBackRemoveStore={this.handleRemoveStore.bind(this)} />)}
            </div>
        );

    }
}

export default EditPageContentStores;



// WEBPACK FOOTER //
// ./src/adm/componentes/EditPageContentStores.js